<template>
  <div>
    <div class="row">
      <div class="col">
        <h3>
          {{ $t('レンタルNo.') }} {{ this.$root.$store.state.reserveIdShort }}
        </h3>
        {{this.$root.data}}
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <div class="form-control-static">
            {{ $t('message.language') }}
          </div>
          <div class="btn-group">
            <button
              :class="{btn: true, 'btn-primary': this.$parent.$i18n.locale == 'ja', 'btn-secondary': this.$parent.$i18n.locale != 'ja'}"
              @click.prevent="changeLang('ja')">
              日本語
            </button>
            <button
              :class="{btn: true, 'btn-primary': this.$parent.$i18n.locale == 'en', 'btn-secondary': this.$parent.$i18n.locale != 'en'}"
              class="btn btn-default"
              @click.prevent="changeLang('en')">
              English
            </button>
            <button
              :class="{btn: true, 'btn-primary': this.$parent.$i18n.locale == 'cn', 'btn-secondary': this.$parent.$i18n.locale != 'cn'}"
              class="btn btn-default"
              @click.prevent="changeLang('cn')">
              中文
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col text-right">
            {{ $t('message.rentalDate') }}
          </div>
          <div class="col text-left">
            {{ this.$root.$store.state.rentalDate }}
          </div>

          <div class="w-100 mt-2" />
          <div class="col text-right">
            {{ $t('message.receiveTime') }}
          </div>
          <div
            v-if="showEditWillVisit === false"
            class="col text-left">
            {{ willVisitFrom }}
            {{ $t('message.receiveTimeTo') }}
            {{ willVisitTo }}
            <button
              class="btn btn-link ml-4"
              type="button"
              @click="editWillVisit">
              {{ $t('変更する') }}
            </button>
          </div>
          <div
            v-if="showEditWillVisit === true"
            class="col text-left">
            <div class="form-inline">
              <div class="form-group">
                <select
                  class="form-control"
                  :value="this.$root.$store.state.willVisit">
                  <option
                    v-for="(v, i) in times"
                    :key="'times-' + i"
                    :value="i">
                    {{ v }}
                  </option>
                </select>
              </div>
              <div class="form-group ml-2">
                {{ $t('message.receiveTimeTo') }}
              </div>
              <div class="form-group ml-2">
                {{ willVisitTo }}
              </div>
              <div class="btn-group">
                <button
                  class="btn btn-info ml-4"
                  type="button"
                  @click="updateWillVisit">
                  {{ $t('更新する') }}
                </button>
                <button
                  class="btn btn-light"
                  type="button"
                  @click="closeWillVisit">
                  {{ $t('更新しない') }}
                </button>
              </div>
            </div>
          </div>

          <div class="w-100 mt-2" />
          <div class="col text-right">
            {{ $t('ご利用時間') }}
          </div>
          <div class="col text-left">
            {{ $t('message.reserveTerm' + this.$root.$store.state.reserve_term) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'
import Underscore from 'vue-underscore'
import moment from 'moment'
import axios from 'axios'

Vue.use(Underscore)

export default {
  name: 'MyPage',
  data () {
    return {
      times: [],
      showEditWillVisit: false
    }
  },
  computed: {
    priceTotal () {
      let m = this.$root.$store.state.members
      let total = 0
      m.forEach((t, index) => {
        let items = t.rentalItems
        if (parseInt(t.itemCategoryPrice) > 0) {
          total += parseInt(t.itemCategoryPrice)
        }
        if (items) {
          this.$_.each(items, function (item, index) {
            total += parseInt(item.price)
          })
        }
      })
      return total
    },
    willVisitFrom () {
      let t = this.$root.$store.state.willVisit
      if (t && this.times[t]) {
        let tmp = this.times[t]
        let m = moment(tmp, 'HH:mm')
        return m.format('HH:mm')
      }
      return null
    },
    willVisitTo () {
      let t = this.$root.$store.state.willVisit
      if (t && this.times[t]) {
        let tmp = this.times[t]
        let m = moment(tmp, 'HH:mm')
        return m.add(10, 'minutes').format('HH:mm')
      }
      return null
    }
  },
  mounted () {
    // console.log(this.$root.$store.state)
  },
  created () {
    this.getEntryTime()
  },
  methods: {
    closeWillVisit () {
      this.showEditWillVisit = false
    },
    editWillVisit () {
      this.showEditWillVisit = true
    },
    correctReserve () {
      console.log('Register::correct')
      // console.log('state', this.$root.$store.state)
      let ui = this.$root.$route.query.ui
      let dev = this.$root.$route.query.dev
      let introduceType = this.$root.$route.query.type
      let url = this.$root.baseURL + 'addReserve.json?ts=' + new Date().getTime()
      let data = this.$root.$store.state
      data.ui = ui
      data.type = introduceType
      data.dev = dev

      let debug = false
      if (debug === true) {
        // console.log(data)
        return false
      }
      axios.post(url,
        JSON.stringify(data),
        {
          headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'json'
        }
      ).then(response => {
        // console.log(response.data)
        if (response.data.result === 'OK') {
          this.$root.$store.commit('update', { field: 'step', value: 5 })
          this.$root.$store.commit('update', { field: 'reserveId', value: response.data.reserveId })
          this.$root.$store.commit('update', { field: 'reserveIdShort', value: response.data.reserveIdShort })
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.$root.$store.state.loading = false
      })

      return false
    },
    updateWillVisit (e) {
      this.$root.$store.commit('update', { field: 'willVisit', value: e.target.value })
    },
    changeLang: function (lang) {
      this.$root.$i18n.locale = lang
      this.$root.$store.commit('update', { field: 'lang', value: lang })
    },
    getEntryTime () {
      let url = this.$root.baseURL + 'getEntryTime.json'
      axios.get(url, {
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'json'
      }).then(response => {
        this.times = response.data.times
        if (!this.$root.$store.state.willVisit) {
          let tmp = response.data.default
          // console.log('tmp', tmp)
          this.$root.$store.commit('update', { field: 'willVisit', value: tmp })
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.$root.$store.state.loading = false
      })
    }
  }
}
</script>
